export default __webpack_public_path__ + "static/media/gamma-coin.ecd578da.png";